<template>
  <div class="lnb-nav">
    <!-- search -->
    <div class="search">
      <w-search-field v-show="isNil(filterObj)" @search="filterTree" />
      <span v-if="!isNil(filterObj)" class="vertical-center-box el-tag el-tag--large el-tag--plain" style="width:100%;height:36px;margin:0px;">
        <div style="width: calc(100% - 30px);text-overflow: ellipsis;overflow: hidden;">
          {{filterObj.label}}
        </div>
        <i class="el-tag__close el-icon-close" style="margin-top:2px;" @click="clearObjFilter"/>
      </span>
    </div>
    <!-- tree -->
    <el-radio-group v-if="disablePhysicalTreeFlag === false" class="search tree-type-radio" style="margin-top:15px; width:100%;" v-model="activeTreeType">
      <el-radio-button style="width:50%;" :label="treeType.LOGICAL"><span>논리 그룹</span></el-radio-button>
      <el-radio-button style="width:50%;" :label="treeType.PHYSICAL"><span>물리 그룹</span></el-radio-button>
    </el-radio-group>
    <div v-if="disablePhysicalTreeFlag === false" style="margin-top:15px; height:calc(100% - 135px); width:100%;">
      <div v-show="activeTreeType === treeType.LOGICAL" style="height:100%;" v-loading="logicalTreeLoading">
          <w-logical-tree v-if="dynamicTreeFlag === false" style="padding-left:18px;" ref="logicalTree" :tree-types="targetTreeTypes" :event-status="eventStatusMap" />
          <w-dynamic-logical-tree v-if="dynamicTreeFlag === true" style="padding-left:18px;" ref="logicalTree" :tree-types="targetTreeTypes" :event-status="eventStatusMap" @show-message="onShowMessage" @filter-obj="onFilterObj"/>
      </div>
      <div v-show="activeTreeType === treeType.PHYSICAL" style="height:100%;" v-loading="physicalTreeLoading">
          <w-physical-tree v-if="dynamicTreeFlag === false" style="padding-left:18px;" ref="physicalTree" :keyword="keyword" :tree-types="targetTreeTypes" :event-status="eventStatusMap" />
          <w-dynamic-physical-tree v-if="dynamicTreeFlag === true" style="padding-left:18px;" ref="physicalTree" :tree-types="targetTreeTypes" :event-status="eventStatusMap" @show-message="onShowMessage" @filter-obj="onFilterObj"/>
      </div>
    </div>
    <div v-else style="margin-top:15px; height:calc(100% - 135px); width:100%;" v-loading="logicalTreeLoading">
      <w-logical-tree v-if="dynamicTreeFlag === false" style="padding-left:18px;" ref="logicalTree" :tree-types="targetTreeTypes" :event-status="eventStatusMap" />
      <w-dynamic-logical-tree v-if="dynamicTreeFlag === true" style="padding-left:18px;" ref="logicalTree" :tree-types="targetTreeTypes" :event-status="eventStatusMap" @show-message="onShowMessage" @filter-obj="onFilterObj"/>
    </div>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import WSearchField from '@/components/form/SearchField';
import { treeType } from '@/constants/tree';
import TreeApi from '@/api/common/tree';
import MsgUtil from '@/utils/message';
import SearchLimitMixin from '@/mixins/tree/search-limit';
import WLogicalTree from './LogicalTree';
import WPhysicalTree from './PhysicalTree';
import WDynamicLogicalTree from './DynamicLogicalTree';
import WDynamicPhysicalTree from './DynamicPhysicalTree';

export default {
  name: 'WTargetTree',
  mixins: [SearchLimitMixin],
  components: {
    WLogicalTree,
    WPhysicalTree,
    WDynamicLogicalTree,
    WDynamicPhysicalTree,
    WSearchField,
  },
  data() {
    return {
      treeType,
      keyword: null,
      logicalLoading: false,
      physicalLoading: false,
      targetTreeTypes: [treeType.LOGICAL, treeType.PHYSICAL],
      activeTreeType: null,
      /**
       * 논리/물리 그룹 트리 노드별 이벤트 상태 객체
       * @type {Object}
       */
      eventStatusMap: null,
      /**
       * 논리/물리 그룹 트리 노드별 이벤트 상태 조회 태스크명
       * @type {String}
       */
      eventStatusTask: 'objEventStatusForTreeTask',
      /**
       * 제공 메시지 정보
       * 논리/물리 그룹 트리가 거의 동시에 동일한 메시지를 제공할 때
       * 메시지가 중복되어 표현되지 않도록 제어하기 위해 사용한다.
       * @type {Object}
       */
      messageInfo: null,
      filterObj: null,
    };
  },
  computed: {
    routeTreeType() {
      return this.$store.state.router.treeType;
    },
    dynamicTreeFlag() {
      return this.$store.state.tree.dynamicTreeFlag;
    },
    disablePhysicalTreeFlag() {
      return this.$store.state.tree.disablePhysicalTreeFlag;
    },
    logicalTreeLoading() {
      return this.$store.state.tree.logicalTreeLoading;
    },
    physicalTreeLoading() {
      return this.$store.state.tree.physicalTreeLoading;
    },
  },
  watch: {
    routeTreeType: {
      handler(value) {
        this.activeTreeType = value;
      },
    },
  },
  created() {
    this.activeTreeType = this.$route.path.indexOf(treeType.PHYSICAL) >= 0 ? treeType.PHYSICAL : treeType.LOGICAL;
    this.loadEventStatusOfTreeNode();
    this.$taskManager.createTask(this.eventStatusTask, 30, () => {
      this.loadEventStatusOfTreeNode();
    });
    this.$taskManager.startTask(this.eventStatusTask);
  },
  beforeDestroy() {
    if (this.dynamicTreeFlag === false) {
      this.$taskManager.removeTask(this.eventStatusTask);
    }
  },
  methods: {
    isNil,
    /**
     * 논리/물리 그룹 트리 노드의 이벤트 상태를 조회한다.
     * @author Ju
     */
    loadEventStatusOfTreeNode() {
      TreeApi.getEventStatusOfTreeNodes().then((response) => {
        if (response.data.success) {
          this.eventStatusMap = response.data.data;
        }
      });
    },
    /**
     * 검색 키워드 기준으로 트리 데이터를 필터링한다.
     * @author Ju
     * @param  {String} value
     */
    filterTree(value) {
      const checkSearchable = this.checkSearchableKeyword(value);
      this.messageInfo = null;
      if (checkSearchable.searchable) {
        this.$refs.logicalTree.filterTree(value);
        if (this.disablePhysicalTreeFlag === false) {
          this.$refs.physicalTree.filterTree(value);
        }
      } else if (!isNil(checkSearchable.message)) {
        this.$message(MsgUtil.getCustomMsgData(checkSearchable.message));
      }
    },
    /**
     * 메시지 제공 이벤트 핸들러
     * @author Ju
     * @param  {String} message
     */
    onShowMessage(message) {
      if (isNil(this.messageInfo) || this.messageInfo.message !== message || new Date().getTime() - this.messageInfo.checkDatetime >= 3000) {
        const infoMessage = this.getSearchInfoMessage(message);
        this.$message(MsgUtil.getCustomMsgData(isNil(infoMessage) ? message : infoMessage));
        this.messageInfo = {
          message,
          checkDatetime: new Date().getTime(),
        };
      }
    },
    /**
     * 장비 필터 이벤트 핸들러
     * @author Ju
     * @param  {Object} obj 장비 정보 객체
     */
    onFilterObj(obj) {
      this.filterObj = obj;
      console.debug('---end set filte obj--', new Date());
    },
    /**
     * 정비 필터를 제거한다.
     * @author Ju
     */
    clearObjFilter() {
      this.filterObj = null;
      this.filterTree();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tree/TargetTree/index.vue